import React from 'react';
import {FormattedMessage} from "react-intl";

import FormikInput from "components/input/new/FormikInput";

import {greyishBlue500} from "assets/jss/main";

function TrackingUrlField(props) {
    return (
        <>
            <FormikInput
                name={'trackingUrl'}
                label={'shippingMethods.form.field.trackingUrl.label'}
                placeholder={'shippingMethods.form.field.trackingUrl.placeholder'}
            />
            <span style={{fontSize: '12px', color: greyishBlue500}}>
                <FormattedMessage id={'shippingMethods.form.field.trackingUrl.help'} values={{placeholder: '{trackingNumber}'}}/>
            </span>
        </>
    );
}

export default TrackingUrlField;
